var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17411 37.048V35.2H1.32211V45H3.25411V41.22H7.06211V39.372H3.25411V37.048H7.17411ZM10.3039 39.204V38H8.49788V45H10.3039V41.654C10.3039 40.184 11.4939 39.764 12.4319 39.876V37.86C11.5499 37.86 10.6679 38.252 10.3039 39.204ZM18.1081 38V41.78C18.1081 42.998 17.4501 43.516 16.5681 43.516C15.7561 43.516 15.1821 43.026 15.1821 42.074V38H13.3761V42.298C13.3761 44.16 14.5381 45.196 16.0221 45.196C16.9601 45.196 17.6881 44.846 18.1081 44.216V45H19.9141V38H18.1081ZM22.4642 37.16C23.0802 37.16 23.5842 36.656 23.5842 36.054C23.5842 35.452 23.0802 34.934 22.4642 34.934C21.8622 34.934 21.3582 35.452 21.3582 36.054C21.3582 36.656 21.8622 37.16 22.4642 37.16ZM21.5682 45H23.3742V38H21.5682V45ZM29.0312 39.736V38H27.4492V36.04L25.6432 36.586V38H24.4252V39.736H25.6432V42.648C25.6432 44.538 26.4972 45.28 29.0312 45V43.362C27.9952 43.418 27.4492 43.404 27.4492 42.648V39.736H29.0312Z",
    fill: "#242629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3428 46.5498L42.3428 41.5498L37.3428 36.5498",
    stroke: "#242629",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5813 8.43385C12.7363 7.3101 9.7913 7.28384 7.56755 8.53509C4.0538 10.5038 3.48006 13.8826 3.37256 16.6051V16.6626C3.39381 16.8351 3.41255 17.0138 3.43255 17.1988C3.4763 17.6701 3.53006 18.2038 3.63631 18.7376C4.24756 21.7538 5.95631 24.3576 9.01381 26.9376C10.6563 28.3238 12.4976 28.6338 14.3476 27.8388C14.8688 27.5926 15.4463 27.4638 16.0313 27.4638C16.6176 27.4638 17.1963 27.5926 17.7163 27.8388C18.3538 28.1138 19.0463 28.2613 19.7488 28.2688C20.9213 28.2688 22.0363 27.8201 23.0388 26.9264L23.1626 26.8176C23.8601 26.2238 24.5163 25.5913 25.1263 24.9201C27.8151 21.8288 28.9663 18.5076 28.5476 15.0438C28.1826 12.0151 26.6838 9.6651 24.3376 8.42885C22.1188 7.2601 19.3476 7.2626 16.7351 8.42885C16.3501 8.4826 15.9638 8.48385 15.5813 8.43385Z",
    stroke: "#D6DE57",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0053 8.43374C15.444 7.39749 15.6153 6.61996 15.444 5.47746C15.2728 4.33496 15.544 3.05499 16.4553 2.24874C16.7353 1.97749 17.1028 1.79624 17.5028 1.73124C17.699 1.72749 17.8953 1.76123 18.0765 1.83248C18.259 1.90248 18.4228 2.00874 18.5578 2.14124C18.9703 2.45749 20.2428 5.42122 12.144 4.90247",
    stroke: "#D6DE57",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38383 14.0713C6.19133 14.3125 6.04883 14.9038 6.04883 15.6101",
    stroke: "#D6DE57",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6124 10.1851C8.72618 10.6126 7.66867 11.2813 7.04492 12.18",
    stroke: "#D6DE57",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieFruit);
export default __webpack_public_path__ + "static/media/pie-fruit.76765f95e22011f7dab81cd61a0daafd.svg";
export { ForwardRef as ReactComponent };